import React from 'react'
import PropTypes from 'prop-types'
import {Link} from 'react-router-dom'
import {Navbar, Nav, NavItem} from 'reactstrap';

// function handleChangeMenu(event) {
//   //event.preventDefault();
//   alert("Zmiana menu");
//   //this.props.onCancel();
// }
// <NavItem key={pos.path}><Link to={pos.path} onClick={handleChangeMenu}>{pos.text} </Link></NavItem>      
const Menu =({positions}) => (
  <Navbar>  
    <Nav className="App-menu">
      {positions.map(pos => (
       <NavItem key={pos.path}><Link to={pos.path}>{pos.text} </Link></NavItem>      
    ))}        
    </Nav>
  </Navbar>
)

Menu.propTypes={
  positions: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,      
    })
  )
}

export default Menu;


// WEBPACK FOOTER //
// ./src/components/Menu.js